import styled from 'styled-components';

export const Container = styled.span`
  color: ${({ theme }) => theme.colors.danger};
  font-size: 18px;
  font-weight: 600;
  line-height: 0.8;
`;
